import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon InfoCircleIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const InfoCircleIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 20 20">
      <path d="M10,0C4.48,0,0,4.48,0,10s4.48,10,10,10s10-4.48,10-10S15.52,0,10,0z M11.43,14.75c0,0.14-0.11,0.25-0.25,0.25h-1.11 c-0.83,0-1.5-0.67-1.5-1.5V9c0-0.14,0.11-0.25,0.25-0.25h1.11c0.83,0,1.5,0.67,1.5,1.5V14.75z M10,7.86c-0.79,0-1.43-0.64-1.43-1.43 S9.21,5,10,5c0.79,0,1.43,0.64,1.43,1.43S10.79,7.86,10,7.86L10,7.86z" />
    </Icon>
  )
}
export default InfoCircleIcon
